import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";
import { BeatLoader, ScaleLoader } from "react-spinners";

const OrderSummaryCartItem = (props) => {
  const [cartItem, setCartItem] = useState();
  const [spinner, setSpinner] = useState(true);
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  const [subTotal, setSubTotal] = useState();

  const GetAllCartItems = () => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      process.env.REACT_APP_BASE_URL +
        `getby_customer_id/${localStorage.getItem("customer_id")}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          setSpinner(false);
        }
        setCartItem(result.data);
      })
      .catch((error) => console.log("error", error));
  };
  const totalPrice =
    cartItem &&
    cartItem.reduce((accumulator, el) => {
      return accumulator + parseInt(el.total_price);
    }, 0);

  useEffect(() => {
    setSubTotal(totalPrice);
    localStorage.setItem("calculateValue", subTotal);
    // console.log('calculateValue', cartItem);
  }, [GetAllCartItems]);

  useEffect(() => {
    GetAllCartItems();
    console.log("Coupon", coupon);
    console.log("User id", localStorage.getItem("customer_id"));
  }, []);

  // Coupon Integration

  // Shipping Cost
  const [shippingCost, setShippingCost] = useState(40);

  // Validate Coupon
  const [coupon, setCoupon] = useState();
  const [couponDetails, setCouponDetails] = useState();

  // Alert
  const [alert, setAlert] = useState(false);

  // Message
  const [message, setMessage] = useState();
  const [searchCoupon, setSearchCoupon] = useState(false);

  const ValidateCoupon = async (e) => {
    e.preventDefault();
    setSearchCoupon(true);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      coupon_code: coupon,
      customer_id: localStorage.getItem("customer_id"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_BASE_URL + "validateCoupon",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setMessage(result.msg);

        if (result.status === 200 && result.data?.is_active === "1") {
          setCouponDetails(result.data);

          // compute discount value here using result.data directly
          let discountValue = 0;
          const value = parseFloat(result.data.coupon_value);

          if (result.data.coupon_type === "₹") {
            discountValue = value;
          } else if (result.data.coupon_type === "%") {
            discountValue = Math.floor((subTotal * value) / 100);
          }

          // save correctly
          localStorage.setItem("CouponID", result.data.id);
          localStorage.setItem("CouponAmount", discountValue);
          localStorage.setItem("couponMsg", result.msg);

          setAlert(true);
        } else {
          // coupon inactive or not found
          setAlert(true);
          setCouponDetails(null);
          localStorage.setItem("CouponID", "");
          localStorage.setItem("CouponAmount", 0);
          localStorage.setItem("couponMsg", "Coupon is invalid or inactive");
          setMessage("Coupon is invalid or inactive");
        }

        setSearchCoupon(false);
      })
      .catch((error) => console.log("error", error));
  };

  const calculateDiscount = () => {
    if (!couponDetails) return 0;

    const value = parseFloat(couponDetails.coupon_value);

    if (couponDetails.coupon_type === "₹") {
      return value; // fixed rupee discount
    } else if (couponDetails.coupon_type === "%") {
      return Math.floor((subTotal * value) / 100); // % of subtotal
    }
    return 0;
  };

  setTimeout(() => {
    setAlert(false);
  }, 5000);

  return (
    <>
      <div className="md:w-full lg:w-2/5 lg:ml-10 xl:ml-14 md:ml-6 flex flex-col h-full md:sticky lg:sticky top-28 md:order-2 lg:order-2">
        <div className="border p-5 lg:px-8 lg:py-8 rounded-lg bg-white order-1 sm:order-2">
          <h2 className="font-semibold font-serif text-lg pb-4">
            Order Summary
          </h2>
          <div className="overflow-y-scroll flex-grow scrollbar-hide w-full max-h-64 bg-gray-50 block">
            {spinner && (
              <div className="max-h-64 flex justify-center">
                <ScaleLoader color="#36d7b7" className="mt-20 mb-20" />
              </div>
            )}
            {cartItem &&
              cartItem.map((el, index) => {
                return (
                  <div
                    className="group w-full h-auto flex justify-start items-center bg-white py-3 px-4 border-b hover:bg-gray-50 transition-all border-gray-100 relative last:border-b-0"
                    key={index}
                  >
                    <div className="relative flex rounded-full border border-gray-100 shadow-sm overflow-hidden flex-shrink-0 cursor-pointer mr-4">
                      <img
                        key=""
                        src={
                          process.env.REACT_APP_MEDIA_BASE_URL +
                          el.products.product_base_image
                        }
                        width={40}
                        height={40}
                        alt=""
                      />
                    </div>
                    <div className="flex flex-col w-full overflow-hidden">
                      <Link href="/">
                        <p
                          // onClick={closeCartDrawer}
                          className="truncate text-sm font-medium text-gray-700 text-heading line-clamp-1"
                        >
                          {el.products.product_name}
                        </p>
                      </Link>
                      <span className="text-xs text-gray-400 mb-1">
                        {el.products.product_desc.slice(0, 100)}
                      </span>
                      <div className="flex items-center justify-between">
                        <div className="font-bold text-sm md:text-base text-heading leading-5">
                          <span className="text-emerald-500">
                            ₹{el.item_price}.00
                          </span>
                        </div>

                        <button
                          // onClick={() => removeItem(item.id)}
                          className="hover:text-red-600 text-red-400 text-lg cursor-pointer"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="flex items-center py-2 text-sm w-full font-semibold text-gray-500 last:border-b-0 last:text-base last:pb-0">
            Subtotal
            <span className="ml-auto flex-shrink-0 text-gray-500 font-bold">
              {"₹" + subTotal}
            </span>
          </div>
          <div className="flex items-center py-2 text-sm w-full font-semibold text-gray-500 last:border-b-0 last:text-base last:pb-0">
            Shipping Cost
            <span className="ml-auto flex-shrink-0 text-grey-700 font-bold">
              {subTotal > 500 ? "FREE" : "₹" + shippingCost}
            </span>
          </div>
          <div className="flex items-center py-2 text-sm w-full font-semibold text-gray-500 last:border-b-0 last:text-base last:pb-0">
            Discount
            <span className="ml-auto flex-shrink-0 font-bold text-red-500">
              {couponDetails ? (
                `- ₹${calculateDiscount()}`
              ) : (
                <span>Not Applied</span>
              )}
            </span>
          </div>
          <div className="border-t mt-4">
            <div className="flex items-center font-bold font-sans justify-between pt-5 text-sm uppercase text-emerald-600">
              Total cost
              <span className="font-sans font-bold text-lg">
                {/* {console.log("subtotal :", subTotal)} */}₹
                {couponDetails
                  ? subTotal > 500
                    ? subTotal - calculateDiscount()
                    : subTotal + shippingCost - calculateDiscount()
                  : subTotal > 500
                  ? subTotal
                  : subTotal + shippingCost}
                /-
              </span>
            </div>
          </div>
          <div>
            <button
              className="w-full flex justify-between items-center p-4 bg-gray-100 hover:bg-gray-200 rounded-b-md"
              onClick={() => toggleSection("coupon")}
            >
              <span className="text-lg font-medium">Apply Coupon</span>
              <span>{openSection === "coupon" ? "▲" : "▼"}</span>
            </button>
            {openSection === "coupon" && (
              <div className="p-4 bg-white">
                <form onSubmit={ValidateCoupon}>
                  <input
                    type="text"
                    placeholder="Enter Coupon Code"
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                    className="w-full p-2 border rounded-md mb-2"
                  />
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 w-full"
                    onClick={() => {
                      ValidateCoupon();
                    }}
                  >
                    Apply
                  </button>
                </form>
                {alert && (
                  <p className="text-green-500 mt-2">
                    {message || "Coupon Applied!"}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderSummaryCartItem;
